/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-25 11:45:05
 * @Explain: 电子邮件配置
 */

import { Effect } from 'umi';
// api
import { domainAuthApi } from '@/api';
// utils
import { getActionType } from '@/utils/common/redux';
// type
import { DomainListItem } from '@/api/domainAuth/data.d';
import { ReducersEnum } from './connect.d';
import { StatusTipEnum, StatusTipType } from '@/definition/common/data.d';
import { SandBoxValidationStateNum } from '@/pages/settingManage/domainAuth/varAndFun';

export interface EmailConfigState {
  domainNameList: DomainListItem[];
  notVerifiedDomainList: DomainListItem[];
  // 域名列表接口状态
  domainNameListStatus: StatusTipType;
}

export type ModelType = {
  namespace: string;
  state: EmailConfigState;
  effects: {
    getDomainNameList: Effect;
  };
  reducers: {
    setDomainNameList: (
      state: EmailConfigState,
      action: { payload: any },
    ) => any;
    setNotVerifiedDomainList: (
      state: EmailConfigState,
      action: { payload: any },
    ) => any;
    setDomainNameListStatus: (
      state: EmailConfigState,
      action: { payload: any },
    ) => any;
  };
};

const EmailConfigModel: ModelType = {
  namespace: 'EmailConfigModel',
  state: {
    // 域名列表
    domainNameList: [],
    // 未验证域名列表
    notVerifiedDomainList: [],
    // 域名列表接口状态
    domainNameListStatus: StatusTipEnum.init,
  },
  effects: {
    // 获取域名列表
    *getDomainNameList({ payload }, { call, put }): any {
      try {
        yield put({
          type: getActionType(ReducersEnum.SET_DOMAIN_NAME_LIST_STATUS),
          payload: StatusTipEnum.loading,
        });
        const result = yield call(domainAuthApi.getList, payload);
        const list: DomainListItem[] = result?.data?.domainList || [];

        let domainNameList =
          list.filter(
            (item) =>
              item.spfStatus === 1 &&
              item.dkimStatus === 1 &&
              item.dmarcStatus === 1,
          ) || [];
        yield put({
          type: getActionType(ReducersEnum.SET_DOMAIN_NAME_LIST),
          payload: domainNameList,
        });
        yield put({
          type: getActionType(ReducersEnum.SET_NOT_VERIFIED_DOMAIN_LIST),
          payload: list.filter(
            (item) => item.status !== SandBoxValidationStateNum.VERIFED,
          ),
        });
        yield put({
          type: getActionType(ReducersEnum.SET_DOMAIN_NAME_LIST_STATUS),
          payload: !!domainNameList?.length
            ? StatusTipEnum.success
            : StatusTipEnum.empty,
        });
      } catch (error: any) {
        console.error('getDomainNameList error');
        yield put({
          type: getActionType(ReducersEnum.SET_DOMAIN_NAME_LIST_STATUS),
          payload: StatusTipEnum.empty,
        });
      }
    },
  },
  reducers: {
    // 设置域名列表
    setDomainNameList(state, action) {
      return {
        ...state,
        domainNameList: action.payload || [],
      };
    },
    // 设置域名列表
    setNotVerifiedDomainList(state, action) {
      return {
        ...state,
        notVerifiedDomainList: action.payload || [],
      };
    },
    // 设置域名列表接口状态
    setDomainNameListStatus(state, action) {
      return {
        ...state,
        domainNameListStatus: action.payload || StatusTipEnum.init,
      };
    },
  },
};

export default EmailConfigModel;
